/**
 * URL
 * @param $path
 * @returns {string|*}
 */
function url($path) {
    var url = window.location.href;

    if (url.indexOf("lhost") != -1) {
        if ($path) {
            return CONF_URL_TEST + $path;
        }
        return CONF_URL_TEST;
    }

    if ($path) {
        return CONF_URL_BASE + $path;
    }

    return CONF_URL_BASE;
}


/**
 * URL THEME
 * @param $path
 * @returns {string}
 */
function theme($path) {
    var url = window.location.href;

    if (url.indexOf("lhost") != -1) {
        if ($path) {
            return CONF_URL_TEST + '/themes/' + CONF_VIEW_THEME + $path;
        }
        return CONF_URL_TEST + '/themes/' + CONF_VIEW_THEME;
    }

    if ($path) {
        return CONF_URL_BASE + '/themes/' + CONF_VIEW_THEME + $path;
    }

    return CONF_URL_BASE + '/themes/' + CONF_VIEW_THEME;
}

/**
 * ICON SPRITE
 * @param $icon
 * @param $class
 * @param $attr
 * @returns {string}
 */
function iconSprite($icon, $class, $attr) {
    return '<svg viewBox="0 0 100 100" class="' + $class + '" ' + $attr + '><use xlink:href="' + url() + '/shared/icons/sprite/sprite.svg#' + $icon + '"></use></svg>';
}

/**
 * GET URL BASE (não utilizando mais)
 * @returns {string}
 */
function getUrlBase() {
    if (location.hostname === "www.localhost") {
        return "http://www.localhost/thermas";
    } else {
        return "https://www.thermas.com.br";
    }
}

/**
 * GET PARAMS
 */
function getUrlParameter() {
    var url = $(location).attr('href');
    var parts = url.split("/");
    return parts;
}

/**
 * CHANGE ELEMENT HEIGHT
 * @param elm
 * @param callback
 */
function onElementHeightChange(elm, callback) {
    var lastHeight = elm.clientHeight
    var newHeight;

    (function run() {
        newHeight = elm.clientHeight;
        if (lastHeight !== newHeight) callback();
        lastHeight = newHeight;

        if (elm.onElementHeightChangeTimer) {
            clearTimeout(elm.onElementHeightChangeTimer);
        }

        elm.onElementHeightChangeTimer = setTimeout(run, 200);
    })();
}

/**
 * SMOOTH SCROLL TO ANCHOR
 * use: data-achor="id_element_to_scroll"
 * @param id
 */
function scrollToAnchor(id){
    const destination = $("#" + id);
    $('html,body').animate({
        scrollTop: destination.offset().top
    },'slow');
}
$('body').on("click", "[data-anchor]", function(e) {
    e.preventDefault();
    var data = $(this).data();
    scrollToAnchor(data.anchor);
});


/**
 * BOOTSTRAP MODAL - CREATE OBJECT
 * @param id
 */
var modal;
function modalBootstrap(id) {
    modal = new bootstrap.Modal(document.getElementById(id), {
        keyboard: true
    });
}

/**
 * BOOTSTRAP MODAL - SHOW
 * @param $size
 * @param $title
 * @param $content
 * @param $nivel
 * @param $footer = false, true
 */
function modalBootstrapShow($size, $title, $content, $nivel=1, $footer) {
    var id = 'modal';
    if ($nivel > 1) {
        id = 'modal' + $nivel
    }

    //set modal
    var modalTitle = $("#" + id + " .modal-title");
    var modalContent = $("#" + id + " .modal-body");
    var modalDialog = $("#" + id + " .modal-dialog");
    var modalSize = $size;

    //set size
    modalDialog.removeClass("modal-sm").removeClass("modal-md").removeClass("modal-lg").removeClass("modal-xl").removeClass("modal-xxl");
    if ($size.length > 10) {
        modalDialog.addClass('modal-fullscreen-' + $size + '-down');
    } else {
        modalDialog.addClass("modal-" + modalSize);
    }

    if ($footer) {
        $("#" + id + " .modal-dialog .modal-footer").removeClass('d-none');
        $("#" + id + " .modal-dialog .modal-footer").html($footer);
    }

    //change content
    modalTitle.html($title);
    modalContent.html($content);

    modalBootstrap(id);
    modal.show();
}

/**
 * BOOTSTRAP MODAL - HIDE
 * @param $nivel
 * @param $event
 */
function modalBootstrapHide($nivel= 1) {
    var id = 'modal';
    if ($nivel > 1) {
        id = 'modal' + $nivel
    }
    modal.hide();
}

/**
 * LOADER
 */
function loaderShow() {
    loader.fadeIn(200);
}
function loaderClose() {
    loader.fadeOut(200);
}
//data- loader
$("[data-loader]").click(function () {
    loader.fadeIn(200);
});

/**
 * SELECT COMBO ESTADO CIDADE
 * @param state
 * @param city
 * @param stateVal
 * @param cityVal
 */
function selectStateCity(state, city, stateVal, cityVal) {
    if (stateVal == undefined && cityVal == undefined) {
        new dgCidadesEstados({
            cidade: document.getElementById(city),
            estado: document.getElementById(state)
        });
    } else {
        new dgCidadesEstados({
            cidade: document.getElementById(city),
            estado: document.getElementById(state),
            estadoVal: stateVal,
            cidadeVal:  cityVal
        });
    }
}